import { v4 as uuid } from 'uuid';
import Plugin from "@uppy/core/lib/BasePlugin";
import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
const firebaseConfig = {
    apiKey: "AIzaSyBtIGxUXPyfRx0O1OCNkfQDx0Nml5hBWWg",
    authDomain: "vahak-2f319.firebaseapp.com",
    projectId: "vahak-2f319",
    storageBucket: "vahak-2f319.appspot.com",
    messagingSenderId: "592281398313",
    appId: "1:592281398313:web:d27dbadf51c821446f0038"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const storage = getStorage(firebaseApp);
export const storageRef = storage;
export default class FirebaseCloudStorage extends Plugin {
    constructor(uppy, opts) {
        super(uppy, opts);
        this.type = "uploader";
        this.id = "FirebaseCloudStorage";
        this.title = "Firebase Cloud Storage";
        this.uploadFile = this.uploadFile.bind(this);
    }
    uploadFile(fileIds) {
        return Promise.all(
            fileIds.map(id => {
                return new Promise((resolve, reject) => {
                    const file = this.uppy.getFile(id);
                    const refId = uuid();
                    const fileRef = ref(storage, refId);
                    const metaData = {
                        contentType: file.type
                    };
                    this.uppy.emit("upload-started", file);
                    const uploadTask = uploadBytesResumable(fileRef, file.data, metaData);
                    uploadTask.on(
                        "state_changed",
                        snapshot => {
                            const progressInfo = {
                                uploader: this,
                                bytesUploaded: snapshot.bytesTransferred,
                                bytesTotal: snapshot.totalBytes
                            };
                            this.uppy.emit("upload-progress", file, progressInfo);
                        },
                        error => {
                            this.uppy.emit("upload-error", file, error);
                            reject(error);
                        },
                        () => {
                            getDownloadURL(uploadTask.snapshot.ref).then(downloadUrl => {
                                const file = this.uppy.getFile(id);
                                file.downloadUrl = downloadUrl;
                                file.refId = refId;
                                this.uppy.emit(
                                    "upload-success",
                                    file,
                                    uploadTask.snapshot,
                                    downloadUrl
                                );
                                resolve();
                            });
                        }
                    );
                });
            })
        );
    }

    install() {
        this.uppy.addUploader(this.uploadFile);
    }

    uninstall() {
        this.uppy.removeUploader(this.uploadFile);
    }
}